<template>
  <b-row>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>
    <b-col cols="12" lg="12">
      <b-card no-header>
        <template slot="header">User Details</template>
        <!-- <b-container v-if="report"> -->
        <div v-if="user">
          <b-row>
            <b-col v-if="user.photo" cols="12" class="py-2">
              <img :src="baseURL+'/u/'+user.photo" height="100px" />
            </b-col>
            <b-col cols="12" md="6">
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Name</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value" v-if="user.name">{{user.name}}</span>
                  <span v-else class="item_value">-</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Phone</span>
                </b-col>
                <b-col cols="7">
                  <span
                    class="item_value"
                    v-if="user.phone"
                  >{{user.phonePrefix}}&nbsp;{{user.phone}}</span>
                  <span v-else class="item_value">-</span>
                </b-col>
              </b-row>
              <hr />
              <!-- <b-row>
                <b-col cols="5">
                  <span class="item_title">Age</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value" v-if="user.age">{{user.age}}</span>
                  <span v-else class="item_value">-</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Occupation</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value" v-if="user.occupation">{{user.occupation}}</span>
                  <span v-else class="item_value">-</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Last Action</span>
                </b-col>
                <b-col cols="7">
                  <span
                    class="item_value"
                    v-if="user.accountCreateAt"
                  >{{formatDate(user.lastactiontime)}}</span>
                  <span v-else class="item_value">-</span>
                </b-col>
              </b-row>
              <hr /> -->
              <b-row>
                <b-col cols="5">
                  <span class="item_title">User Status</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value" v-if="user.status">{{user.status}}</span>
                  <span v-else class="item_value">-</span>
                </b-col>
              </b-row>
              <hr />
            </b-col>
            <!-- ////////// -->
            <b-col cols="12" md="6">
              <b-row>
                <b-col cols="5">
                  <span class="item_title">User Name</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value" v-if="user.username">{{user.username}}</span>
                  <span v-else class="item_value">-</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Email</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value" v-if="user.email">{{user.email}}</span>
                  <span v-else class="item_value">-</span>
                </b-col>
              </b-row>
              <hr />
              
              <!-- <b-row>
                <b-col cols="5">
                  <span class="item_title">Gender</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value" v-if="user.gender">{{user.gender}}</span>
                  <span v-else class="item_value">-</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="5">
                  <span class="item_title">User Type</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value" v-if="user.type">{{user.type}}</span>
                  <span v-else class="item_value">-</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Account Created On</span>
                </b-col>
                <b-col cols="7">
                  <span
                    class="item_value"
                    v-if="user.accountCreateAt"
                  >{{formatDate(user.accountCreateAt)}}</span>
                  <span v-else class="item_value">-</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="5">
                  <span class="item_title">User ID</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value" v-if="user._id">{{user._id}}</span>
                  <span v-else class="item_value">-</span>
                </b-col>
              </b-row>
              <hr /> -->
            </b-col>
          </b-row>
        </div>

        <b-row v-if="admin == 'Admin'" class="justify-content-center">
          <div class="px-2">
            <b-button variant="outline-primary" size="sm" @click.prevent="editUser">Edit</b-button>
          </div>
          <!-- <div class="px-2">
            <b-button
              v-if="userStatus=='Active'"
              variant="outline-danger"
              @click="confirmDeactivateUser"
              size="sm"
            >Deactivate User</b-button>
            <b-button
              v-if="userStatus=='Banned'"
              variant="outline-primary"
              @click="confirmDeactivateUser"
              size="sm"
            >Activate User</b-button>
          </div> -->
          <div class="px-2">
            <b-button variant="danger" size="sm" @click.prevent="confirmRemoveUser">Remove User</b-button>
          </div>
        </b-row>
        <!-- </b-container> -->
        <template slot="footer">
          <b-button @click="$router.go(-1)" size="sm">Back</b-button>
        </template>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import EditUser from "./editUser";
import axios from "axios";
export default {
  props: {
    caption: {
      type: String,
      default: "User id"
    }
  },
  data() {
    return {
      user: null,
      appLoading: false,
      ServerError: false,
      userStatus: null,
      superAdmin: false,
      admin:localStorage.getItem("role")
    };
  },
  mounted() {
    // if (localStorage.getItem("role") != "Sub Admin") this.superAdmin = true;
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/get",
        params: {
          id: this.$route.params.id
        },
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.appLoading = false;
          this.user = response.data.data;
          this.userStatus = this.user.status;
        })
        .catch(e => {
          this.ServerError = true;
        });
    },
    confirmDeactivateUser() {
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to deactivate this user.",
          {
            title: "Please Confirm",
            size: "md",
            buttonSize: "sm",
            okVariant: "danger",
            cancelVariant: "primary",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true
          }
        )
        .then(value => {
          if (value) {
            this.deactivateUser();
          }
        })
        .catch(err => {
          // An error occurred
        });
    },
    confirmRemoveUser() {
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to Remove this user.? All user data will be lost except incident reportings",
          {
            title: "Please Confirm",
            size: "md",
            buttonSize: "sm",
            okVariant: "danger",
            cancelVariant: "primary",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true
          }
        )
        .then(value => {
          if (value) {
            this.removeUser();
          }
        })
        .catch(err => {
          // An error occurred
        });
    },
    editUser() {
      this.$dlg.modal(EditUser, {
        width: 1000,
        height: 500,
        title: "Edit User",
        maxButton: true,
        closeButton: true,
        params: {
          userData: this.user
        },
        callback: data => {
          if (data.update) {
            this.getData();
          }
          if (!data.status) {
            this.ServerError = true;
          }
        }
      });
    },
    deactivateUser() {
      this.appLoading = true;
      var newURL;
      if (this.userStatus == "Banned") {
        // this.userStatus = "Active";
        newURL = "user/activateuser";
      } else if (this.userStatus == "Active") {
        // this.userStatus = "Banned";
        newURL = "user/banuser";
      }
      axios({
        method: "POST",
        // url: "/user/banuser",
        url: newURL,
        data: {
          id: this.$route.params.id
        },
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.appLoading = false;
          this.getData();
        })
        .catch(e => {
          this.ServerError = true;
        });
    },
    removeUser() {
      axios({
        method: "POST",
        url: "/user/removeuser",
        data: {
          id: this.$route.params.id
        },
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.appLoading = false;
          // this.getData();
          this.$router.go(-1);
        })
        .catch(e => {
          this.ServerError = true;
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    }
  }
};
</script>